
import * as yup from "yup";
import {UpdateApplicationRequest, UploadDocumentRequest} from "../searchms/model";

export const UPDATE_APPLICATION_FORM: UpdateApplicationRequest = {
    id: null,
    currentStatus: null,
    areaOfApplicationStatus:  null,
    evaluationOutcome: null,
    postalCode: null,
    dmsLink: null,
    dmsIdentificationCode:  null,
    applicant: {
        id:  null,
        tenant:  null,
        name:  null,
        surname:  null,
        companyName:  null,
        vatNumber: null,
        siren: null,
        siret: null,
        region: null,
        address: null,
        city:  null,
        province: null,
        email:  null,
        phoneNumber:  null,
        notes:  null,
        newPartner:  null,
    }
}

// Validation Schema
export const UPDATE_APPLICATION_FORM_VALIDATION_SCHEMA = yup.object();

export const APPLICATION_DOCUMENTS_FORM_VALIDATION_SCHEMA = yup.object().shape({
    to: yup.date().nullable(),
    from: yup.date().nullable(),
    documents: yup.array().of(yup.object().shape({
        file: yup.string().required("Required"),
        title: yup.string().nullable().required("Required"),
        note: yup.string().ensure().when('title', {
            is: 'Other',
            then: yup.string().required("Required field")
        })
    }))
});

export const APPLICATION_SEND_EMAIL_FORM_VALIDATION_SCHEMA = yup.object().shape({
    email: yup.string().email().required()
});

export enum APPLICATION_STATES {
    CREATED='CREATED',
    REJECTED_BY_COMMITTEE='REJECTED_BY_COMMITTEE',
    REJECTED_BY_AUTHORITIES='REJECTED_BY_AUTHORITIES',
    SUSPENDED_BY_COMMITTEE='SUSPENDED_BY_COMMITTEE',
    ACCEPTED_BY_COMMITTEE='ACCEPTED_BY_COMMITTEE',
    NOT_APPROVED='NOT_APPROVED',
    APPROVED='APPROVED',
}

export const FINAL_STATES =[
    APPLICATION_STATES.APPROVED,
    APPLICATION_STATES.NOT_APPROVED,
    APPLICATION_STATES.REJECTED_BY_COMMITTEE
]

export enum APPLICATION_SUBSTATES {
    COMMITTEE_NOT_PASSED="Committee verification not passed",
    COMMITTEE_PASSED_AREA_TAKEN="Committee verification passed but area's taken",
    COMMITTEE_PASSEDAREA_VACANT="Committee verification passed and area's vacant",
    UNDERWRITING_NOT_PASSED="Underwriting verification not passed",
    SECURITY_NOT_PASSED="Security verification not passed",
    UNDERWRITING_SECURITY_NOT_PASSED="Underwriting and security verification not passed",
    APPROVED_UNDERWRITING_SECURIRTY="Approved by Underwriting and Security",
    PARTNERS_COMMITTEE_APPROVAL="Partners committee approval",
    PARTNER_COMMITTEE_REJECT="Partners committee rejection",
}

export const APPLICATION_SUBSTATES_AGGREGATED = {
    [APPLICATION_STATES.CREATED as string] : [
        APPLICATION_SUBSTATES.COMMITTEE_NOT_PASSED,
        APPLICATION_SUBSTATES.COMMITTEE_PASSED_AREA_TAKEN,
        APPLICATION_SUBSTATES.COMMITTEE_PASSEDAREA_VACANT
    ],
    [APPLICATION_STATES.ACCEPTED_BY_COMMITTEE as string] : 
    [
        APPLICATION_SUBSTATES.UNDERWRITING_NOT_PASSED,
        APPLICATION_SUBSTATES.SECURITY_NOT_PASSED,
        APPLICATION_SUBSTATES.UNDERWRITING_SECURITY_NOT_PASSED,
        APPLICATION_SUBSTATES.APPROVED_UNDERWRITING_SECURIRTY,
    ],
    [APPLICATION_STATES.REJECTED_BY_AUTHORITIES as string] :
    [
        APPLICATION_SUBSTATES.PARTNERS_COMMITTEE_APPROVAL,
        APPLICATION_SUBSTATES.PARTNER_COMMITTEE_REJECT
    ],
    [APPLICATION_STATES.SUSPENDED_BY_COMMITTEE as string] : [
        APPLICATION_SUBSTATES.COMMITTEE_NOT_PASSED,
        APPLICATION_SUBSTATES.COMMITTEE_PASSEDAREA_VACANT,
    ],
};

// export const valInApplicationStates = (value: string): value is keyof APPLICATION_SUBSTATES_AGGREGATED => Object.keys(APPLICATION_SUBSTATES_AGGREGATED).includes(value);